<template>
  <div id="app">
    <transition name="custom-classes-transition" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style src="animate.css/animate.min.css"></style>



// WEBPACK FOOTER //
// src/App.vue